<template>
	<Modal
    :value="visible"
    @on-cancel="cancelHandler"
    footer-hide
    :title="curVar && curVar.id ? '编辑变量' : '增加变量'"
		width="500">
		<div class="container">
			<Form :model="formData" ref="form" label-position='left' :label-width="100" :rules="ruleValidate">
				<FormItem label="变量名称" prop="name">
					<Input v-model="formData.name" placeholder="" />
				</FormItem>
				<FormItem label="变量类型">
					<Select v-model="formData.type">
						<Option value="NUM">数字</Option>
						<Option value="STR">字符串</Option>
					</Select>      
				</FormItem>
				<FormItem label="变量初始值">
					<Input v-model="formData.value"/>
				</FormItem>
				<FormItem label="是否导出">
					<i-switch v-model="formData.export"/>
				</FormItem>
				<FormItem label="只执行一次">
					<i-switch v-model="formData.first_valid"/>
				</FormItem>
				<div class="flex flex-end">
					<Button style="margin-right: 20px" @click="cancelHandler">取消</Button>
					<Button type="primary" @click="submit">确定</Button>
				</div>
			</Form>
		</div>
	</Modal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curVar: {
      type: Object,
    }
  },
	data() {
		return {
			formData: {
				name: '',
				type: 'NUM',
        value: '',
        export: false,
        first_valid: false,
      },
      ruleValidate: {
        name: [
          { required: true, message: '变量名不能为空', trigger: 'blur' },
          {
            type: 'string',
            validator: (rule, value) => {
              if (this.curVar?.id && value === this.curVar.id) return true;
              const index = this.vars?.findIndex(item => item.name === value);
              return !(index >= 0)
            },
            message: '该变量已经存在'
          }
        ],
      }
		}
	},
	computed: {
    ...mapState('setting', [
			'vars',
    ]),
	},
	watch: {
		curVar(val) {
			if (!val) return
      this.formData = { ...val }
		}
	},
	methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
				this.$emit('onSubmit', { ...this.formData });
        this.cancelHandler();
      })
    },
		cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
				name: '',
				type: 'NUM',
        value: '',
        export: false,
        first_valid: false,
      }
      this.$emit('change', false)
      this.$emit('onCancel')
    },
	}
}
</script>
<style lang="scss" scoped>
</style>